interface EditIconProps {
  className?: string;
}

export const EditIcon = ({ className }: EditIconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1692 3.65995L3.58222 11.6905C3.29575 11.9954 3.01852 12.5961 2.96307 13.012L2.62115 16.0061C2.50102 17.0873 3.27727 17.8266 4.34923 17.6417L7.32486 17.1335C7.74071 17.0596 8.32293 16.7546 8.6094 16.4404L16.1963 8.40987C17.5086 7.0237 18.1 5.44348 16.0577 3.51209C14.0247 1.59919 12.4814 2.27379 11.1692 3.65995Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.90381 5C10.3012 7.55054 12.3712 9.50041 14.9402 9.75911"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
